import { BaseChannel } from "../../base/env";

const INITIAL_STATE = {
  credit: 0,
  cart_credit: 0,
  user_id: "",
  token: "",
  refreshToken: "",
  channel: BaseChannel,
  email: "",
  last_name: "",
  first_name: "",
  phone_number: "",
  country_id: "",
  country_name: "",
  discount_code: "",
  is_login: false,
  close_adv: false,
  product_id: 1,
  checkoutId: "",
  transactionId: "",
  paymentOptions: [],
  cart_data: {
    total_amount: 0,
    total_quantity: 0,
    payable_amount: 0,
    discount_amount: 0,
    total_usable_credit: 0,
    tax_amount: 0,
    wallet_amount: 0,
  },
  cid: "",
  cpid: "gmall",
  urlCode: "",
  pendingChannel: "",
  pendingCid: "",
  pendingCpid: "",
  channelClaimed: true,
  openNewNotification: true,
  notificationPopover: true,
  /** When true, one-time channel bootstrap in store/index load_state has already run for this persisted profile */
  channelBootstrapDone: true,
};

const Login = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        first_name: action.user.first_name,
        last_name: action.user.last_name,
        email: action.user.email,
        close_adv: false,
        token: action.user.token,
        refreshToken: action.user.refreshToken,
        user_id: action.user.id,
        country_code: action.user.countryCode,
        phone_number: action.user.phone_number,
      };

    case "FINAL_LOGIN_SUCCESS":
      return {
        ...state,
        is_login: true,
        urlCode: "",
      };
    case "SET_I_SUCCESS":
      return {
        ...state,
        first_name: action.user.first_name,
        last_name: action.user.last_name,
        email: action.user.email,
        // user: action.user,
        phone_number: action.user.phone_number,
      };

    case "USER_EDIT_SUCCESS":
      return {
        ...state,
        first_name: action.user.first_name,
        last_name: action.user.last_name,
      };

    case "STORE_SUCCESS":
      return {
        ...state,
        country_id: action.country_id,
        country_name: action.country_name,
        channel: action.channel,
      };

    case "LOGOUT_SUCCESS":
      return {
        ...state,
        first_name: "",
        last_name: "",
        email: "",
        credit: 0,
        close_adv: false,
        user: "",
        token: "",
        refreshToken: "",
        is_login: false,
        discount_code: "",
        checkoutId: "",
        channel: state.channel === "saudi-channel" ? "saudi-channel" : BaseChannel,
        cid: "",
        cpid: "gmall",
        channelClaimed: true,
        pendingChannel: "",
        pendingCpid: "",
        pendingCid: "",
      };

    case "SET_DISCOUNT_CODE":
      return {
        ...state,
        credit: action.data.credit,
        discount_code: action.data.discount_code,
      };

    case "CLOSE_ADV":
      return { ...state, close_adv: true };

    case "INIT_STATE":
      return { ...state };

    case "INCREASE_CREDIT":
      return {
        ...state,
        cart_credit: state.cart_credit + action.credit,
        credit: state.credit - action.credit,
      };

    case "SET_CART_DATA":
      return {
        ...state,
        cart_credit: action.credit,
        cart_data: action.cart_data,
      };

    case "SET_PRODUCT_ID":
      return {
        ...state,
        product_id: action.product_id,
      };
    case "SET_USER_TOKEN":
      return {
        ...state,
        token: action.token,
      };
    case "SET_CHECKOUT_ID":
      return {
        ...state,
        checkoutId: action.payload.checkout_id,
      };
    case "SET_TRANSACTION_ID":
      return {
        ...state,
        transactionId: action.payload,
      };

    case "SET_CHANNEL": {
      const channelChanged = action.channel !== state.channel;
      return {
        ...state,
        channel: action.channel,
        pendingChannel: "",
        ...(channelChanged ? { cart_data: INITIAL_STATE.cart_data } : {}),
      };
    }

    case "SET_CREDIT":
      return {
        ...state,
        credit: action.payload,
      };
    case "SET_PAYMENT_OPTIONS":
      return {
        ...state,
        paymentOptions: action.payload,
      };
    case "SET_CURRENCY":
      return {
        ...state,
        currency: action.payload,
      };
    case "LOGIN_PHONE_NUMBER":
      return {
        ...state,
        phone_number: action.user.phone_number,
        country_code: action.user.country_code,
      };
    case "SET_CID":
      return { ...state, cid: action.payload };

    case "SET_CPID":
      return { ...state, cpid: action.payload };

    case "SET_URL_CODE":
      return { ...state, urlCode: action.payload };

    case "SET_OPEN_NEW_NOTIFICATION":
      return { ...state, openNewNotification: action.payload };

    case "SET_NOTIFICATION_POPOVER":
      return { ...state, notificationPopover: action.payload };

    case "SET_PENDING_CHANNEL":
      return {
        ...state,
        pendingChannel: action.channel,
      };

    case "SET_PENDING_CPID":
      return {
        ...state,
        pendingCpid: action.cpid,
      };

    case "SET_PENDING_CID":
      return {
        ...state,
        pendingCid: action.cid,
      };

    case "CLEAR_ALL_PENDING":
      return {
        ...state,
        pendingChannel: "",
        pendingCid: "",
        pendingCpid: "",
      };

    case "SET_CHANNEL_CLAIMED":
      return {
        ...state,
        channel: action.channel,
        cpid: action.cpid ?? state.cpid,
        cid: action.cid ?? state.cid,
        pendingChannel: "",
        pendingCpid: "",
        pendingCid: "",
        channelClaimed: true,
        ...(action.clearCart === false
          ? {}
          : { cart_data: INITIAL_STATE.cart_data }),
      };

    default:
      return state;
  }
};
export default Login;
